import { Box, Button, Chip, Paper, Stack, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { DetailRow } from '../../components/Cards/DetailsBox'
import moment from 'moment'
import { TenantSettingsContext } from '../../App'
import { useNavigate } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import { formatTravelSummary, getTravelMinutes } from '../../helpers/shiftTravel'

const RecentShiftPopup = ({ shift, onClose }) => {
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig
  const navigate = useNavigate()
  const needsEndOfShiftReport =
    !shift?.endOfShiftReportCompleted &&
    !shift?.isVerified &&
    moment(shift.start).isBefore(moment())

  console.log('SHIFT', shift)

  return (
    <Box
      component={Paper}
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        borderRadius: 1,
        boxShadow: 24,
        borderColor: 'none',
        maxHeight: 500,
        overflow: 'auto',
        outline: 'none',
        p: 2,
      }}
      width={{ xs: '80%', lg: 'auto' }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="title2">
            {shift?.event?.title ?? 'Shift'}
          </Typography>
          {shift?.eventAssignment && (
            <Typography variant="caption">{shift.eventAssignment}</Typography>
          )}
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <DetailRow
            label="Start"
            value={moment(shift.start).format('Do MMM YYYY HH:mm')}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <DetailRow
            label="End"
            value={moment(shift.end).format('Do MMM YYYY HH:mm')}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <DetailRow
            label="Pay Rate"
            value={`${orgSettings?.currency ?? '£'}${shift.payRate}/${shift.hourlyRate ? 'hr' : 'shift'}`}
          />
        </Grid>
        {(shift.bonuses ?? []).length > 0 && (
          <Grid item xs={12} md={6} lg={4}>
            <DetailRow
              label="Fixed Bonuses"
              value={shift.bonuses
                .map(
                  (bonus) =>
                    `${orgSettings?.currency ?? '£'}${bonus.amount}${bonus.label ? ` ${bonus.label}` : ''}`,
                )
                .join(', ')}
            />
          </Grid>
        )}
        {getTravelMinutes(shift.travel) > 0 && (
          <Grid item xs={12} md={6} lg={4}>
            <DetailRow
              label="Paid Travel"
              value={formatTravelSummary(
                shift.travel,
                orgSettings?.currency ?? '£',
              )}
            />
          </Grid>
        )}

        {shift?.clock?.startedAt && (
          <Grid item xs={12} md={6} lg={4}>
            <DetailRow
              label="Clocked In"
              value={moment(shift.clock.startedAt).format('HH:mm')}
            />
          </Grid>
        )}
        {shift?.clock?.lateStartReason && (
          <Grid item xs={12} md={6} lg={4}>
            <DetailRow label="Late Start" value={shift.clock.lateStartReason} />
          </Grid>
        )}
        {shift?.overTime?.required && (
          <Grid item xs={12} md={6} lg={4}>
            <DetailRow label="Overtime Claim">
              <Box
                sx={{
                  width: 'fit-content',
                  alignItems: 'center',
                  justifyContent: 'center',
                  px: 1,
                  py: 0.25,
                  borderRadius: 1,
                  backgroundColor:
                    shift.overTime.status === 'Approved'
                      ? 'anGreen.main'
                      : shift.overTime.status === 'Rejected'
                        ? 'anRed.main'
                        : 'contrast.main',
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    color: '#fff',
                    lineHeight: 1.2,
                    textAlign: 'center',
                  }}
                >
                  {shift.overTime.status}
                </Typography>
              </Box>
            </DetailRow>
          </Grid>
        )}
        <Grid item xs={12} md={6} lg={4}>
          <DetailRow
            label={
              shift?.overTime?.status === 'Pending'
                ? 'Claimed Overtime'
                : 'Approved Overtime'
            }
            value={`${shift?.overTime?.decidedMinutes ?? 0} minutes`}
          />
        </Grid>
        {shift?.clock?.lateEndReason && (
          <Grid item xs={12} md={6} lg={4}>
            <DetailRow label="Late Finish" value={shift.clock.lateEndReason} />
          </Grid>
        )}
        <Grid item xs={12}>
          <Button
            variant="contained"
            size="small"
            fullWidth
            color="error"
            onClick={() => onClose()}
          >
            Close
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default RecentShiftPopup
